import React from 'react';
import PropTypes from 'prop-types';
import CsvImportFlow from '../common/CsvImportFlow';

/**
 * Enhanced version of the ImportLeadsStep for the onboarding wizard
 * that uses the new CSV import flow with column mapping
 */
const ImportLeadsWithMapping = ({ onNext, onSkip, onPrev }) => {
  // Handle import completion
  const handleImportComplete = (results) => {
    if (results.success && results.isComplete) {
      // If import was successful and user clicked "Done", move to next step
      onNext();
    }
  };

  return (
    <div>
      <h2 className="text-2xl font-semibold mb-4">Import Your Leads</h2>
      <p className="text-gray-600 mb-6">
        Upload a CSV file with your contacts. Our intelligent mapping system will help you match your columns to the correct fields.
      </p>
      
      {/* CSV Import Flow Component */}
      <div className="mb-8 border border-gray-200 rounded-lg p-4 bg-white">
        <CsvImportFlow
          entityType="leads"
          onImportComplete={handleImportComplete}
          isSimplifiedMode={true} // Use simplified mode for onboarding
        />
      </div>
      
      {/* Navigation Buttons */}
      <div className="flex justify-between">
        <button
          onClick={onPrev}
          className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400"
        >
          Back
        </button>
        
        <button
          onClick={onSkip}
          className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400"
        >
          Skip for Now
        </button>
      </div>
    </div>
  );
};

ImportLeadsWithMapping.propTypes = {
  onNext: PropTypes.func.isRequired,
  onSkip: PropTypes.func.isRequired,
  onPrev: PropTypes.func.isRequired
};

export default ImportLeadsWithMapping;